module.exports = __webpack_public_path__ + "img/video-preview.031a80ba.jpg";